module.exports = "<cabecalho-portal [fantasia]=\"fantasia\" (toogleMenu)=\"toggleSidebar()\"></cabecalho-portal>\r\n\r\n<menu-lateral [collapsed]=\"isCollapsed\" (atualizaCollapsed)=\"toggleSidebar()\" [itensMenu]=\"itensMenuLateral\"></menu-lateral>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/layout/layout/layout.component.html
// module id = ../../../../../src/app/layout/layout/layout.component.html
// module chunks = 1